export function dataInRequest(params = {}) {
  return {
    type: '@perfilFrentista/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@perfilFrentista/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@perfilFrentista/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@perfilFrentista/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@perfilFrentista/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@perfilFrentista/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@perfilFrentista/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@perfilFrentista/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@perfilFrentista/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@perfilFrentista/RECORD_FILTERING',
    payload: { params },
  };
}
